var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10418 5.6717C7.42418 8.66106 10.8542 13.0849 10.8542 13.0849V18.1006C10.8542 19.2041 11.7542 20.1069 12.8542 20.1069C13.9542 20.1069 14.8542 19.2041 14.8542 18.1006V13.0849C14.8542 13.0849 18.2842 8.66106 20.6042 5.6717C21.1142 5.00963 20.6442 4.05664 19.8042 4.05664H5.89418C5.06418 4.05664 4.59418 5.00963 5.10418 5.6717Z",
    fill: "#FC7013"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilter);
export default __webpack_public_path__ + "static/media/search-filter.b8aa4e94ef866514d35dbd2f9e68042a.svg";
export { ForwardRef as ReactComponent };